import { type TwStyle } from 'twin.macro';
import FormikCheckbox from '@components/elements/FormikCheckbox/FormikCheckbox';
import useAppModuleConfig from '@hooks/useAppModuleConfig';
import { type BrandTerm } from '@tsTypes/api/BrandTerm';

import ConsentCheckboxLabel from './ConsentCheckboxLabel';

type Props = {
  name: string;
  term: BrandTerm;
  bonus?: number | null;
  lineClamp?: number;
  dataTestid?: string;
  isRequired?: boolean;
  cssExtend?: { wrapper?: TwStyle };
};

const ConsentCheckbox = ({
  name,
  term,
  bonus = null,
  lineClamp,
  dataTestid,
  isRequired = false,
  cssExtend,
}: Props) => {
  const pointsNames = useAppModuleConfig('MoneyBox');

  return (
    <FormikCheckbox
      name={name}
      label={
        <ConsentCheckboxLabel
          term={term}
          bonus={bonus}
          lineClamp={lineClamp}
          pointsNames={pointsNames}
        />
      }
      dataTestid={dataTestid}
      isRequired={isRequired}
      cssExtend={cssExtend}
    />
  );
};

export default ConsentCheckbox;
